import React, {Component} from 'react';
import ReactTooltip, { tooltipClasses }  from '@mui/material/Tooltip';
import { styled } from '@mui/system';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import './tooltip.less';
import Languages  from './Languages';

const StyledTooltip = styled(({ className, ...props }) => (
  <ReactTooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: "black",
    backgroundColor: "white",
    fontSize: "0.8rem",
    boxShadow: "rgba(0, 0, 0, 0.80) 0px 10px 20px",
  },
  [`& .${tooltipClasses.tooltipPlacementBottom}`]: {
    margin:"0.4rem 0.8rem",
  },
}));

export default class Tooltip extends Component{
    constructor(props){
        super(props)
    }
    
    _handleClickAway(){
        this.props.handleClickAway()
    }

    render(){
        return(
            <ClickAwayListener onClickAway={this._handleClickAway.bind(this)}>
                <div>
                    <StyledTooltip                       
                        placement="bottom"
                        open={this.props.open}
                        interactive 
                        title={<Languages languageList={this.props.languageList}/>}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                    >
                        {this.props.children}
                    </StyledTooltip>
                </div>
            </ClickAwayListener>
        )
    }
}
